import constants from "../../core/constants";

class Controller {
  constructor($injector, $stateParams) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.Events = $injector.get("Events");
    this.Messages = $injector.get("Messages");
    this.Sections = $injector.get("Sections");
    this.BasicPlan = $injector.get("BasicPlan");
    this.BasicPlanTransforms = $injector.get("BasicPlanTransforms");

    this.onUpdateEvent = this.Events.getUpdateEvent("basicPlan");

    this.sections = this.Sections.plansSections;
  }

  $onInit() {
    const showNotificationEvent = this.Events.eventsType
      .onShowSuccessNotification;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const onUpdate = (options) => {
      const params = {};
      params[options.key] =
        typeof options.value !== "undefined"
          ? options.value
          : options.name
          ? options.name._id
          : null;
      if (options.key === "rate" || options.key === "extra_rate") {
        params[options.key] = options.value * constants.currencyBy;
      }

      this.BasicPlan.update(this.$stateParams.id, params).$promise.then(
        () => {
          this.basicPlan[options.key].isDisabled = true;
          this.Events.emit(
            showNotificationEvent,
            this.Messages.updateMessage("basic plan", options.key)
          );
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };

    this.BasicPlan.get(this.$stateParams.id).$promise.then((response) => {
      this.basicPlan = this.BasicPlanTransforms.justify(response);
    });
    this.Events.on(this.onUpdateEvent, onUpdate);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/basicPlan/basicPlan.controller.js